import React from 'react';
import PropTypes from 'prop-types';
import { inViewForReact } from 'utils/common';
import Link from 'components/Link';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import throttle from 'lodash.throttle';
import {
  PRC_FOR_NEVER_REGISTER,
  PRC_FOR_SUBSCRIBED,
  PRC_FOR_SUBSCRIPTION_EXPIRED,
  PRC_FOR_SUBSCRIPTION_CANCELLED,
} from 'constants/index';
import {
  checkGracePeriod,
  getPreExpiryFormattedTime,
  getGraceFormattedTime,
  checkPreExpireDate,
  checkIfOneDayRemaining,
} from 'utils/primeUtil';
import s from './HPPrimeInlineWidget.scss';

class HPPrimeInlineWidget extends React.Component {
  constructor() {
    super();
    this.state = {};
    this.textObject = undefined;
    this.gaFiredView = false;
    this.containerRef = React.createRef();
    this.showOffers = false;
  }

  componentDidMount() {
    this.throttledGAonScroll = throttle(this.handleScrollEvent, 100);
    window.addEventListener('scroll', this.throttledGAonScroll);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userPrcData !== this.props.userPrcData) {
      getPreExpiryFormattedTime(this.props.userPrcData).then(res => {
        this.setState({ daysRemaining: res });
      });
      getGraceFormattedTime(this.props.userPrcData).then(res => {
        this.setState({ graceDate: res });
      });
      checkGracePeriod(this.props.userPrcData).then(res => {
        this.setState({ inGracePeriod: res });
      });
      checkPreExpireDate(this.props.userPrcData).then(res => {
        this.setState({ isPreExpired: res });
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledGAonScroll);
  }

  handleScrollEvent = () => {
    const node = this.containerRef.current;
    if (node && !this.gaFiredView && inViewForReact(node, 0, true)) {
      this.gaFiredView = true;
      const cta = this.getCTA(
        this.props.prc,
        this.props.hpPrimeInlineWidgetTranslation,
      );
      // const textData = hpPrimeInlineWidgetTranslation[PRC_FOR_NEVER_REGISTER];
      const grxParams = [
        'paywall',
        {
          client_source: 'cdp',
          event_nature: 'impression',
          event_category: 'subscription',
          cta_text: cta || 'Subscribe',
          // event_section: 'homepage_prime_slider',
          // event_sub_section: '',
          // landing_l1: 'plan_page',
          // landing_l2: '',
          // landing_l3: '',
          // landing_page_template: 'home',
          // landing_url: redirectToNewPlanpage(
          //   newPlanpageMetaData(textData),
          // ),
          // position: 4,
        },
      ];
      if (typeof window?.grx_module?.hitPaywallEventReact === 'function') {
        window.grx_module.hitPaywallEventReact(...grxParams);
      } else {
        window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
          eventName: grxParams[0],
          payload: grxParams[1],
        });
      }
      this.props.clickHandler(
        null,
        {
          type: 'firega',
          ga_action: 'TOIPlus_InlineWidgets|View',
          ga_label: `PS_${this.props.prc}`,
          nonInteraction: true,
        },
        true,
      );
    }
  };

  getUTMs = isWap => {
    const utms = {};
    utms.utm_source = 'TOI';
    utms.utm_medium = 'InlineWidget';
    utms.utm_campaign = isWap ? 'Referral_Wap_TOI' : 'Referral_Web_TOI';
    return utms;
  };

  getCTA = (prc, txtData) => {
    const cta =
      prc === PRC_FOR_SUBSCRIPTION_EXPIRED ||
      prc === PRC_FOR_SUBSCRIPTION_CANCELLED
        ? txtData[PRC_FOR_SUBSCRIPTION_EXPIRED] &&
          txtData[PRC_FOR_SUBSCRIPTION_EXPIRED].ctaTxt
        : txtData[PRC_FOR_NEVER_REGISTER] &&
          txtData[PRC_FOR_NEVER_REGISTER].ctaTxt;
    return cta;
  };

  getHTMLMobile = hpPrimeInlineWidgetTranslation => {
    const { prc, clickHandler, isWapView } = this.props;
    const utms = this.getUTMs(isWapView);
    const cta = this.getCTA(prc, hpPrimeInlineWidgetTranslation);
    const textData = hpPrimeInlineWidgetTranslation[PRC_FOR_NEVER_REGISTER];

    if (!textData) {
      return null;
    }

    return (
      <div className={s.inlinewidget} ref={this.containerRef}>
        <Link
          className={s.btn}
          to={redirectToNewPlanpage(newPlanpageMetaData(textData))}
          onClick={e =>
            clickHandler(
              e,
              {
                type: 'newPlanPage',
                utms,
                ga_action: `TOIPlus_InlineWidgets|CTA-${cta}-click`,
                ga_label: `PS_${prc}`,
                nudgeType: 'TOIPlus_InlineWidgets',
                cta_text: cta,
              },
              true,
            )
          }
        >
          {cta}
        </Link>
      </div>
    );
  };

  getHTMLDesktop = hpPrimeInlineWidgetTranslation => {
    const { prc, clickHandler, isWapView } = this.props;
    const utms = this.getUTMs(isWapView);
    const cta = this.getCTA(prc, hpPrimeInlineWidgetTranslation);
    const textData = hpPrimeInlineWidgetTranslation[PRC_FOR_NEVER_REGISTER];

    if (!textData) {
      return null;
    }

    return (
      <>
        {/* <a href="/toi-plus"> */}
        <i className={s.logo} />
        <Link
          to={redirectToNewPlanpage(newPlanpageMetaData(textData))}
          onClick={e => clickHandler(e, { type: 'newPlanPage', cta_text: cta })}
          className={s.secCtaTxt}
        >
          {textData && textData.secCtaTxt}
        </Link>
        {/* </a> */}
        <div className={s.inlinewidget} ref={this.containerRef}>
          {/* <div>Exclusive access to</div> */}
          <ul>
            {hpPrimeInlineWidgetTranslation &&
              hpPrimeInlineWidgetTranslation.benefits &&
              hpPrimeInlineWidgetTranslation.benefits.map(benefit => (
                <li>{benefit.text}</li>
              ))}
          </ul>
          <Link
            className={s.btn}
            to={redirectToNewPlanpage(newPlanpageMetaData(textData))}
            onClick={e =>
              clickHandler(
                e,
                {
                  type: 'newPlanPage',
                  utms,
                  ga_action: `TOIPlus_InlineWidgets|CTA-${cta}-click`,
                  ga_label: `PS_${prc}`,
                  nudgeType: 'TOIPlus_InlineWidgets',
                },
                true,
              )
            }
          >
            {cta}
          </Link>
        </div>
      </>
    );
  };

  getPreExpiryHTML = () => {
    const { toiHpWidget, prc, isWapView, clickHandler } = this.props;
    const { preExpiry } = toiHpWidget;
    const utms = this.getUTMs(isWapView);

    if (!preExpiry) {
      return null;
    }
    const oneDayRemaining = checkIfOneDayRemaining(this.state.daysRemaining);
    const days = !oneDayRemaining
      ? `${this.state.daysRemaining} days`
      : 'Today';
    const daysRemaining = preExpiry?.h1?.replace(
      `<span class='expriedaysremaining'><remainingDays></span>`,
      `${
        !oneDayRemaining ? 'in' : ''
      } <span class=expriedaysremaining>${days}</span>`,
    );
    return (
      <div className={s.renewalSection}>
        <a href="/toi-plus" className={s.renewalLogo}>
          <i className={s.logo} />
        </a>
        <p
          className={s.renewalTitle}
          dangerouslySetInnerHTML={{
            __html: daysRemaining,
          }}
        />
        <p
          className={s.renewalDesc}
          dangerouslySetInnerHTML={{
            __html: preExpiry?.h2,
          }}
        />
        <Link
          className={s.renewalBtn}
          to={redirectToNewPlanpage(newPlanpageMetaData(preExpiry))}
          target="_blank"
          rel="noreferrer"
          onClick={e =>
            clickHandler(
              e,
              {
                type: 'newPlanPage',
                utms,
                ga_action: `TOIPlus_InlineWidgets|CTA-${
                  preExpiry?.ctaTxt
                }-click`,
                ga_label: `PS_${prc}`,
                nudgeType: 'TOIPlus_InlineWidgets',
                item_category3: 'EarlyRenew_Homepage_Inline_Nudge',
                cta_text: preExpiry?.ctaTxt,
              },
              true,
            )
          }
        >
          {preExpiry?.ctaTxt}
        </Link>
      </div>
    );
  };

  getGraceHTML = () => {
    const { toiHpWidget, prc, isWapView, clickHandler } = this.props;
    const { grace } = toiHpWidget;
    const utms = this.getUTMs(isWapView);

    if (!grace) {
      return null;
    }
    const graceDate = grace.h2.replace(
      '<gracedate>',
      `${this.state.graceDate}`,
    );
    return (
      <div className={s.renewalSection}>
        <a href="/toi-plus" className={s.renewalLogo}>
          <i className={s.logo} />
        </a>
        <p className={s.renewalTitle}>{grace.h1}</p>
        <p
          className={s.renewalDesc}
          dangerouslySetInnerHTML={{
            __html: graceDate,
          }}
        />
        <Link
          className={s.renewalBtn}
          to={redirectToNewPlanpage(newPlanpageMetaData(grace))}
          target="_blank"
          rel="noreferrer"
          onClick={e =>
            clickHandler(
              e,
              {
                type: 'newPlanPage',
                utms,
                ga_action: `TOIPlus_InlineWidgets|CTA-${grace?.ctaTxt}-click`,
                ga_label: `PS_${prc}`,
                nudgeType: 'TOIPlus_InlineWidgets',
                item_category3: 'Grace_Homepage_Inline_Nudge',
                cta_text: grace.ctaTxt,
              },
              true,
            )
          }
        >
          {grace.ctaTxt}
        </Link>
      </div>
    );
  };

  getSubscribedHTML = txtData => {
    if (!txtData) {
      return null;
    }
    return (
      <>
        <a href="/toi-plus">
          <i className={s.logo} />
        </a>
        <div className={s.inlinewidget} ref={this.containerRef}>
          <div className={s.title}>{txtData && txtData.h1}</div>
          <div className={s.text_decs}>{txtData && txtData.h2}</div>
          <a
            className={s.btn}
            href={txtData && txtData.ctaLink}
            target="_blank"
            rel="noreferrer"
          >
            {txtData && txtData.ctaTxt}
          </a>
        </div>
      </>
    );
  };

  render() {
    const { prc, isWapView, hpPrimeInlineWidgetTranslation = {} } = this.props;
    if (this.state.inGracePeriod) {
      return this.getGraceHTML();
    } else if (this.state.isPreExpired) {
      return this.getPreExpiryHTML();
    }

    return (
      <>
        {isWapView && this.getHTMLMobile(hpPrimeInlineWidgetTranslation)}
        {!isWapView &&
          prc === PRC_FOR_SUBSCRIBED &&
          this.getSubscribedHTML(
            hpPrimeInlineWidgetTranslation[PRC_FOR_SUBSCRIBED],
          )}
        {!isWapView &&
          prc !== PRC_FOR_SUBSCRIBED &&
          this.getHTMLDesktop(hpPrimeInlineWidgetTranslation)}
      </>
    );
  }
}

HPPrimeInlineWidget.propTypes = {
  isWapView: PropTypes.bool.isRequired,
  prc: PropTypes.number.isRequired,
  clickHandler: PropTypes.func.isRequired,
  hpPrimeInlineWidgetTranslation: PropTypes.shape({}),
};

HPPrimeInlineWidget.defaultProps = {
  hpPrimeInlineWidgetTranslation: {},
};

export default HPPrimeInlineWidget;
